// ../../API/basic/Exaustor/acionar.js
/**
 * POST para acionar exaustor (manual) ou unidade (individual).
 * - Manual: envia unidadeId como string "Exaustor X"
 * - Unidade: envia unidadeId como number (ex.: 301)
 *
 * Retorna o corpo JSON do back (ou null em erro), seguindo o padrão do listar.js.
 */

import { nodeRedApi } from "../../../services/axios";

export const acionarExaustor = async (exaustor, _command, unidadeIdOverride = null) => {
  try {
    if (!exaustor || typeof exaustor !== "object") {
      console.error("Parâmetro 'exaustor' inválido.");
      return null;
    }

    // Decide o que enviar:
    // - number => modo unidade
    // - string "Exaustor X" => modo manual
    const unidadeId =
      typeof unidadeIdOverride === "number"
        ? unidadeIdOverride
        : typeof exaustor.id === "string" && exaustor.id.toLowerCase().startsWith("exaustor")
          ? exaustor.id
          : `Exaustor ${exaustor.id}`;

    const body = {
      unidadeId,
      exaustorId: exaustor.id,
    };

    // Se seu baseURL já aponta para "...", aqui você usa só o path:
    // POST {baseURL}/exaustor
    const { data } = await nodeRedApi.post("/exaustor", body);

    console.log("POST /exaustor/acionar →", data);
    return data;
  } catch (error) {
    const status = error?.response?.status;
    const data = error?.response?.data;

    console.error(`Falha na requisição HTTP POST${status ? ` (${status})` : ""}.`, data ?? error);
    return null;
  }
};

/**
 * Helper para acionar/desligar uma UNIDADE específica (modo unidade).
 * Usa o mesmo endpoint, porém envia number no payload (unidadeId).
 */
export const acionarUnidade = (exaustor, unidadeId) => {
  const idNum = Number(unidadeId);
  if (Number.isNaN(idNum)) {
    console.error("unidadeId inválido para acionarUnidade:", unidadeId);
    return Promise.resolve(null);
  }
  return acionarExaustor(exaustor, null, idNum);
};

export default acionarExaustor;